export default {
  Search: require('./Search').default
}